import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {CloudflareService} from "../../websites/website/booster/services/cloudflare.service";
import {LoadCloudflareData, LoadCloudflareDefaultRecord} from "../actions";
import * as cloudflareDataActions from '../actions/cloudflare-data.action';

@Injectable()
export class CloudflareDataEffects {

  loadCloudflareData$ = createEffect(() => this._actions$.pipe(
    ofType(cloudflareDataActions.LOAD_CLOUDFLARE_DATA),
    mergeMap((action: LoadCloudflareData) => {
      return this._cloudflareService.getCloudflareDate(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new cloudflareDataActions.LoadCloudflareDataSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new cloudflareDataActions.LoadCloudflareDataFail(response.message);
          })
        );
    })
  ));
  loadCloudflareDefaultRecord$ = createEffect(() => this._actions$.pipe(
    ofType(cloudflareDataActions.LOAD_CLOUDFLARE_DEFAULT_RECORD),
    mergeMap((action: LoadCloudflareDefaultRecord) => {
      return this._cloudflareService.getDefaultDnsRecord(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new cloudflareDataActions.LoadCloudflareDefaultRecordSuccess({
                websiteId: action.payload,
                dnsRecords: response.data
              });
            }
            return new cloudflareDataActions.LoadCloudflareDefaultRecordFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _cloudflareService: CloudflareService
  ) {
  }


}
